import React from 'react';

export interface PuCostBarProps {
  fee: number;
  insurance: number;
  patient: number;
}

export function PuCostBar({ fee, insurance, patient }: PuCostBarProps) {
  if (fee <= 0) return null;

  const insPct = Math.max(0, Math.min(100, (insurance / fee) * 100));
  const patPct = Math.max(0, Math.min(100, (patient / fee) * 100));

  return (
    <div className="mb-2.5">
      <div
        className="flex overflow-hidden rounded-full shadow-[inset_0_1px_1px_var(--cream-2)]"
        style={{ height: 10, background: 'var(--surface-mute)' }}
      >
        {insurance > 0 ? (
          <div
            style={{
              width: `${insPct}%`,
              background:
                'linear-gradient(90deg, color-mix(in srgb, var(--success) 62%, #fff), var(--success))',
            }}
          />
        ) : null}
        <div
          style={{
            width: `${patPct}%`,
            background:
              'linear-gradient(90deg, color-mix(in srgb, var(--gold) 60%, #fff), var(--gold))',
          }}
        />
      </div>
      <div className="mt-2 flex items-center gap-4 text-[11.5px] text-[var(--ink-3)]">
        {insurance > 0 ? (
          <span className="inline-flex items-center gap-1.5">
            <span className="h-[9px] w-[9px] rounded-[3px] bg-[var(--success)]" />
            Insurance covers
          </span>
        ) : null}
        <span className="inline-flex items-center gap-1.5">
          <span className="h-[9px] w-[9px] rounded-[3px] bg-[var(--gold)]" />
          Your portion
        </span>
      </div>
    </div>
  );
}
